import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { COMPANY_TYPES } from '../../../../../utils/common'
import { selectCompanyInfo } from '../../../../common/header/companyInfo/store/slice'
import classes from './index.module.scss'
import { Portfolio } from './tabs/Portfolio'
import { Revenue } from './tabs/Revenue'
import { YearOfOperation } from './tabs/YearOfOperation'

const TAB_LIST = {
  PORTFOLIO: {
    label: 'companyAnalysis.peerAnalysis.PORTFOLIO',
    key: 'PORTFOLIO',
    checkDisabled: false,
    children: <Portfolio />,
  },
  REVENUE: {
    label: 'companyAnalysis.peerAnalysis.REVENUE',
    key: 'REVENUE',
    checkDisabled: true,
    children: <Revenue />,
  },
  YEARS_OF_OPERATION: {
    label: 'companyAnalysis.peerAnalysis.YEARS_OF_OPERATION',
    key: 'YEARS_OF_OPERATION',
    checkDisabled: false,
    children: <YearOfOperation />,
  },
}

export const TabsTable = () => {
  const [activeTab, setActiveTab] = useState(TAB_LIST.PORTFOLIO.key)
  const { companyType } = useSelector(selectCompanyInfo)

  const onClickTab = (item) => {
    if (!(companyType !== COMPANY_TYPES.CORPORATE && item.checkDisabled)) {
      setActiveTab(item.key)
    }
  }

  return (
    <div className="w70">
      <Element className={classes.tabContainer}>
        <Element
          className={classes.tabs}
          style={{
            borderBottomWidth: 1,
            borderBottomColor: '#B5CEF8',
            borderBottomStyle: 'solid',
          }}
        >
          {Object.values(TAB_LIST).map((tab) => (
            <Element
              key={tab.key}
              className={classes.tabItem}
              style={
                tab.key === activeTab
                  ? {
                      color: '#FFFFFF',
                      backgroundColor: '#2C73E8',
                      marginRight: 4,
                      padding: '2px 8px',
                    }
                  : {
                      color:
                        companyType !== COMPANY_TYPES.CORPORATE &&
                        tab.checkDisabled
                          ? '#D5D5D5'
                          : '#191D25',
                      backgroundColor: '#F3F3F3',
                      marginRight: 4,
                      padding: '2px 8px',
                      cursor:
                        companyType !== COMPANY_TYPES.CORPORATE &&
                        tab.checkDisabled
                          ? 'not-allowed'
                          : 'pointer',
                    }
              }
              onClick={() => onClickTab(tab)}
            >
              <Translate value={tab.label} />
            </Element>
          ))}
        </Element>

        <div>{TAB_LIST[activeTab].children}</div>
      </Element>
    </div>
  )
}
